IREP.FiveStarHub = (function (global, $) {
    var OnlineParticipant = function (avatar) {
        var self = this;

        this.avatar = avatar;
        this.avatarImage = ko.computed(function () {
            return IREP.options.apiUrl + "participant/avatar/" + self.avatar;
        });
    };

    var Comment = function (id, name, text, createdDate) {
        var self = this;
        this.id = id;
        this.name = name;
        this.text = text;
        this.createdDate = createdDate;
        this.dateText = ko.observable(moment(createdDate).fromNow());

        setInterval(function () {
            self.dateText(moment(self.createdDate).fromNow())
        }, 10000);
    };

    var FiveStarHub = function (options) {
        var self = this;

        var defaultOptions = {
            paxuid: ''
        };

        this.options = $.extend(this.options, defaultOptions, options);
        this.$chat = $('#FiveStarMain .stream .chat');

        this.onlineParticipants = ko.observableArray([]);
        this.comments = ko.observableArray([]);

        this.onlineParticipants.extend({ rateLimit: 50 });
        //this.comments.extend({ rateLimit: 50 });

        this.hub = $.connection.fiveStarHub;
        this.server = this.hub.server;
        this.hub.client.broadcastMessage = function (message) {
            self.broadcastMessage(message);
        };
        this.hub.client.connected = function (message) {
            self.connected(message);
        };
        this.hub.client.participantConnected = function (message) {
            self.participantConnected(message);
        };
        this.hub.client.participantDisconnected = function (message) {
            self.participantDisconnected(message);
        };
        this.hub.client.flagMessage = function (message) {
            self.flagMessage(false, message.CommentID);
        };

        $.connection.hub.qs = { paxuid: options.paxuid }
        $.connection.hub.start({}, function (a, b, c) {
            $('#FiveStarMain .stream').find('a').on('click', function (e) {
                e.preventDefault();
                self.sendMessage($(this).siblings('input').val());
                $(this).siblings('input').val('')
            });

            $('#FiveStarMain .stream').on('click', '.flag', function (e) {
                var commentID = $(this).data('commentid');
                self.flagMessage(true, commentID);
            });

            $('#FiveStarMain .stream input').on('keypress', function (e) {
                if (e.which === 13) {
                    self.sendMessage($(this).val());
                    $(this).val('')
                }
            });

            self.currentWrapperPosition = 0;
            $('#FiveStarMain .stream .prev').on('click', function (e) {
                var wrapper = $(this).parent().find('.wrapper');
                if (wrapper.children().length > 10 && self.currentWrapperPosition + 10 < wrapper.children().length) {
                    self.currentWrapperPosition++;
                    wrapper.animate({ left: "-=85px" });
                }
            });

            $('#FiveStarMain .stream .next').on('click', function (e) {
                var wrapper = $(this).parent().find('.wrapper');
                if (wrapper.children().length > 10 && self.currentWrapperPosition > 0) {
                    self.currentWrapperPosition--;
                    wrapper.animate({ left: "+=85px" });
                }
            });
        });

        ko.applyBindings(this, $('#FiveStarMain .stream')[0]);
    };

    //FiveStarHub.prototype = new IREP.Hub();
    //FiveStarHub.prototype.constructor = FiveStarHub;

    FiveStarHub.prototype.sendMessage = function (message) {
        var self = this;

        self.server.message(message);
    };

    FiveStarHub.prototype.connected = function (message) {
        var self = this;

        $.each(message.OnlineParticipants, function (i, e) {
            self.onlineParticipants.push(new OnlineParticipant(e));
        });

        $.each(message.LatestComments, function (i, e) {
            self.comments.push(new Comment(e.ID, e.Name, e.Text, e.CreatedDate));
        });

        self.scrollChatToBottom();
    }

    FiveStarHub.prototype.participantConnected = function (message) {
        var self = this;

        var results = $.grep(self.onlineParticipants(), function (e, i) {
            return e.avatar === message.Avatar;
        });

        if (results.length === 0) {
            self.onlineParticipants.push(new OnlineParticipant(message.Avatar));
        }
    }

    FiveStarHub.prototype.participantDisconnected = function (message) {
        var self = this;

        var results = $.grep(self.onlineParticipants(), function (e, i) {
            return e.avatar === message.Avatar;
        });

        if (results.length > 0) {
            self.onlineParticipants.remove(results[0]);
        }

        var $wrapper = $('#FiveStarMain .stream .wrapper');
        if (self.currentWrapperPosition > 0) {
            self.currentWrapperPosition--;
            wrapper.animate({ left: "+=85px" });
        }
    };

    FiveStarHub.prototype.broadcastMessage = function (message) {
        var self = this;

        self.comments.push(new Comment(message.ID, message.Name, message.Text, message.CreatedDate));

        self.scrollChatToBottom();
    };

    FiveStarHub.prototype.flagMessage = function (clientInitiated, messageID) {
        var self = this;

        if (clientInitiated === true) {
            self.server.flagMessage(messageID);
        }
        self.removeMessage(messageID);
    };

    FiveStarHub.prototype.removeMessage = function (messageID) {
        var self = this;

        self.comments.remove(function (item) { return item.id === messageID; });
    };

    FiveStarHub.prototype.scrollChatToBottom = function () {
        var self = this;

        self.$chat.scrollTop(self.$chat[0].scrollHeight);
    }

    return FiveStarHub;
}(this, jQuery));
